import { render } from "./EmptyStateCard.vue?vue&type=template&id=0fb373af&scoped=true"
import script from "./EmptyStateCard.vue?vue&type=script&lang=js"
export * from "./EmptyStateCard.vue?vue&type=script&lang=js"

import "./EmptyStateCard.vue?vue&type=style&index=0&id=0fb373af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb373af"]])

export default __exports__